import { KeyboardDatePicker } from '@material-ui/pickers';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumentoDetalleConsultaGeneral from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/IDocumentoDetalleConsultaGeneral';

import useStyles from '../DetallesInventarioEstilos';

interface ICampoFechaIngresoProps {
    deshabilitado: boolean;
    detalle: IDocumentoDetalleConsultaGeneral;
    manejarCambioCampo: (
        documentoDetalleId: string,
        nombreCampo: keyof IDocumentoDetalleConsultaGeneral,
        nuevoValor: any
    ) => void;
}

const CampoFechaIngreso: FunctionComponent<ICampoFechaIngresoProps> = ({
    deshabilitado,
    detalle,
    manejarCambioCampo,
}) => {
    const classes = useStyles();

    return (
        <KeyboardDatePicker
            className={classes.campo}
            disabled={deshabilitado}
            disablePast
            format="DD/MM/YYYY"
            fullWidth
            label={<Texto id="TablaDetallesPlantilla.FechaIngreso" />}
            onChange={(date) => {
                if (date) manejarCambioCampo(detalle.DocumentoDetalleId, 'FechaIngreso', date.format('YYYY-MM-DD'));
            }}
            size="small"
            value={detalle.FechaIngreso || null}
            id={`CampoFechaIngreso-${detalle.FechaIngreso || null}`}
        />
    );
};

export default CampoFechaIngreso;
